import React, { useEffect, useState, useRef } from 'react'
import { Password } from 'primereact/password'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button';
import { useFormInput } from './hooks';
import { authenticationService } from "./services"
import { otherTool } from "./tools"
import { Toast } from 'primereact/toast';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';
import './login.scss';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primeicons/primeicons.css';
import './index.scss';

const localizationDefault =
{
    "wrongSecurityCode": "Güvenlik kodu yanlış!",
    "nullSecurityCode": "Güvenlik kodu boş geçilemez!",
    "enterUsernameAndPassword": "Kullanıcı adı ve şifre giriniz.",
    "somethingWentWrong": "Beklenmeyen bir hata oluştu!",
    "successResetPasswordMail": "Şifre sıfırlama linki kayıtlı email adresinize gönderildi.",
    "failResetPasswordMail": "Şifre sıfırlama linki gönderilemedi!",
    "labelUsername": "Kullanıcı Adı",
    "labelPassword": "Şifre",
    "labelRememberMe": "Beni Hatırla",
    "labelForgotPassword": "Şifremi Unuttum",
    "labelLogin": "Giriş Yap",
    "labelLoginOtp": "Kod Gönder",
    "labelLoginOtpValidate": "Kodu Onayla",
    "labelRegister": "Kayıt Ol",
    "labelRegisterText": "Kayıtlı değil misiniz?",
    "labelResetPassword": "Şifreyi Sıfırla",
    "labelResetPasswordText": "Kullanıcı adınızı veya mailinizi giriniz. Yeni parola oluşturabilmeniz için e-posta yoluyla bir bağlantı alacaksınız.",
    "labelUsernameOrEmail": "Kullanıcı Adı ve ya Email",
    "labelSentMail": "Gönder",
    "labelBackLoginScreen": "Giriş Ekranına Geri Dön.",
    "labelEdevlet": "Edevlet ile Giriş Yap",
    "labelOtp": "Otp ile giriş yap",
    "labelMobileConfirmationCode": "Mobil Onay Kodu",
    "labelUserNameNotFound": "Kullanıcı adı bulunamadı.",
    "labelOtpSuccessMessage": "Lütfen sistemde kayıtlı telefon numaranıza gönderilen 6 haneli şifreyi giriniz",
    "labelOtpMessageWrong": "Yanlış şifre girdiniz",
    "labelOptNotUser": "Bu kullanıcı sistemimizde bulunmamaktadır"
}

let reelCaptcha = null;


export const Login = (props) => {

    const [isOtp, setIsOtp] = useState(props.otp);

    const [otpValidate, setOtpValidate] = useState(false);

    const [otpResponse, setOtpResponse] = useState(null);

    const [confirmationCode, setConfirmationCode] = useState(null);

    const [isRememberMe, setIsRememberMe] = useState(false);

    const [forgetPassword, changeForgetPassword] = useState(true);

    const [wrongPassword, setWrongPassword] = useState(false);

    const username = useFormInput("");

    const mobileConfirmationCode = useFormInput("");

    const password = useFormInput("");

    const captcha = useFormInput("");

    const [isLoading, setIsLoading] = useState(false);

    const [isResetLoading, setIsResetLoading] = useState(false);

    const [domainList, setDomainList] = useState([]);

    const [selectedDomainName, setSelectedDomainName] = useState(null);

    const [correctOptValueCount, setCorrectOptValueCount] = useState(3);

    const toast = useRef(null);

    const localization = { ...localizationDefault, ...props.localization };

    useEffect(() => {
        if (!props.captcha)
            props.localStorageUserKey ?
                localStorage.removeItem(props.localStorageUserKey) :
                localStorage.removeItem(props.appName + "-user");

        if (props.captcha && forgetPassword) {

            reelCaptcha = otherTool.createCaptcha();
        }

        if (props.rememberMe) {

            const usernameRm = localStorage.getItem(props.appName + "-username-rm");

            if (usernameRm) {

                username.setValue(usernameRm);

                setIsRememberMe(true);
            }
        }

        setOtpResponse(null);

        document.getElementsByClassName('bs-login')[0].classList.add(props.theme)
    }, [])
    useEffect(() => {

        if (props.domainSelection) {
            let data = {
                "keyFilter": "LdapDomain"
            };
            authenticationService.getLdapDomains(props.url, data).then(response => {
                if (response.success) {
                    setDomainList(response.data);
                }
            });
        }
    }, []);

    useEffect(() => {
        if (wrongPassword)
            reelCaptcha = otherTool.createCaptcha();
        captcha.onReset();
    }, [wrongPassword])


    const otpLogin = () => {
        const formattedUsername = selectedDomainName ? `${selectedDomainName}/${username.value}` : username.value;
        if (isOtp && otpResponse == null) {
            authenticationService.getOtpToken(
                {
                    username: formattedUsername,
                    password: "*",
                },
                props.otpUrl
            )
                .then(response => {
                    if (props.onOtpSuccess) {
                        props.onOtpSuccess(response);
                    }
                    if (response.success) {
                        setOtpResponse(response.data);
                        setOtpValidate(true);

                        toast.current.show({
                            severity: 'success',
                            detail: localization.labelOtpSuccessMessage,
                            life: 3000
                        });
                    }
                    else {
                        if (response.data.message == "NoRecord") {
                            toast.current.show({
                                severity: 'error',
                                detail: localization.labelOptNotUser,
                                life: 3000
                            });
                        }
                        else {
                            toast.current.show({
                                severity: 'error',
                                detail: response.message,
                                life: 3000
                            });
                        }

                    }

                }).catch(ex => {
                    console.error(ex);

                    toast.current.show({
                        severity: 'error',
                        detail: localization.somethingWentWrong,
                        life: 3000
                    });
                })
                .finally(() => {
                    setIsLoading(false);

                });

            return;
        }
        if (otpResponse != null) {
            let _val = { ...otpResponse };
            _val.validateNumber = mobileConfirmationCode.value;

            authenticationService.getOtpTokenValidate(
                _val,
                props.otpValidateUrl
            )
                .then(response => {
                    if (props.onPromise) {
                        return props.onPromise(response);
                    }
                    if (props.onOtpValidateSucess) {
                        props.onOtpValidateSucess(response);
                    }

                    if (!response.success) {

                        toast.current.show({
                            severity: 'error',
                            detail: response.message,
                            life: 3000
                        });

                        setCorrectOptValueCount(correctOptValueCount - 1);

                        if (correctOptValueCount - 1 <= 0) {
                            setOtpResponse(null);
                        }

                        return;

                    }          
                    loginAction({ pass: response.data.token });
                })
                .catch(ex => {
                    console.error(ex);

                    toast.current.show({
                        severity: 'error',
                        detail: localization.somethingWentWrong,
                        life: 3000
                    });
                })
                .finally(() => {
                    setIsLoading(false);

                    if (props.captcha) {
                        reelCaptcha = otherTool.createCaptcha();
                        captcha.onReset();
                    }
                });

            return;
        }

    }
    const login = () => {
        const formattedUsername = selectedDomainName ? `${selectedDomainName}/${username.value}` : username.value;

        if (!formattedUsername || !password.value) {
            toast.current.show({
                severity: 'info',
                detail: localization.enterUsernameAndPassword,
                life: 3000
            });

            reelCaptcha = otherTool.createCaptcha();
            captcha.onReset();
            return;
        }

        if ((props.captcha || wrongPassword)) {
            if (!captcha.value) {
                toast.current.show({
                    severity: 'info',
                    detail: localization.nullSecurityCode,
                    life: 3000
                });

                reelCaptcha = otherTool.createCaptcha();
                captcha.onReset();
                return;
            } else if (captcha.value !== reelCaptcha) {
                toast.current.show({
                    severity: 'info',
                    detail: localization.wrongSecurityCode,
                    life: 3000
                });

                reelCaptcha = otherTool.createCaptcha();
                captcha.onReset();
                return;
            }


        }

        if (props.onClick) {
            return props.onClick(formattedUsername, password.value, setIsLoading);
        }

        setIsLoading(true);

        if (props.onRequest) {
            return props.onRequest(formattedUsername, password.value, setIsLoading);
        }

        loginAction();
    };


    const loginAction = (data) => {
        console.log(data);
        const formattedUsername = selectedDomainName ? `${selectedDomainName}/${username.value}` : username.value;

        authenticationService.login(
            {
                username: formattedUsername,
                password: data ? data.pass : password.value,
                retriesControl: props.retriesControl,
                retriesCount: props.retriesCount,
                captchaControl: props.captcha
            },
            props.url
        )
            .then(response => {
                if (props.onPromise) {
                    return props.onPromise(response);
                }

                if (!response.success) {
                    if (response.data.retries >= props.retriesCount) {
                        setWrongPassword(true);
                    }

                    toast.current.show({
                        severity: 'error',
                        detail: response.message,
                        life: 3000
                    });

                    return;
                }

                if (props.rememberMe && isRememberMe) {
                    localStorage.setItem(props.appName + "-username-rm", formattedUsername);
                } else if (props.rememberMe && !isRememberMe) {
                    localStorage.removeItem(props.appName + "-username-rm");
                }

                if (props.onSuccess) {
                    props.onSuccess(response.data);
                }
            })
            .catch(ex => {
                console.error(ex);

                toast.current.show({
                    severity: 'error',
                    detail: localization.somethingWentWrong,
                    life: 3000
                });
            })
            .finally(() => {
                setIsLoading(false);

                if (props.captcha) {
                    reelCaptcha = otherTool.createCaptcha();
                    captcha.onReset();
                }
            });
    }
    const sendResetPasswordLink = () => {

        if (!username.value) {

            toast.current.show({
                severity: 'info',
                detail: localization.somethingWentWrong,
                life: 3000
            });

            return;
        }

        setIsResetLoading(true);

        authenticationService.sendResetPasswordLink({ email: username.value }, props.url).
            then(response => {

                if (!response.success) {

                    toast.current.show({
                        severity: 'error',
                        detail: response.message,
                        life: 3000
                    });

                    return;
                }

                toast.current.show({
                    severity: 'success',
                    detail: localization.successResetPasswordMail,
                    life: 3000
                });

                setTimeout(() => {

                    changeForgetPassword(true);

                }, 3000);
            }).
            catch(ex => {

                toast.current.show({
                    severity: 'error',
                    detail: localization.failResetPasswordMail,
                    life: 3000
                });

            }).finally(() => {

                setIsResetLoading(false);
            })
    }

    return (
        <>
            <Toast ref={toast} />

            <div className="bs-login">
                {props.image &&
                    <div className='item bs-img-side'>
                        <img src={props.image} className="bs-img" />
                    </div>
                }
                <div className='item bs-login-side'>
                    <div className='bs-login-form'>
                        {forgetPassword ?
                            <>
                                {props.logo &&
                                    <img className='bs-logo' src={props.logo}></img>
                                }
                                {props.appName &&
                                    <h3 className='bs-app-name'>{props.appName}</h3>
                                }

                                <div className="card flex flex-column">
                                    {/* <div className="p-inputgroup bs-inputgroup">
                                        <span className="p-inputgroup-addon">
                                            <i className="pi pi-user"></i>
                                        </span>
                                        {props.domainSelection &&
                                            <Dropdown value={selectedDomainName} onChange={(e) => setSelectedDomainName(e.value)} options={domainList} optionLabel="value"
                                                showClear placeholder="Seçim Yapınız" className="w-full" />
                                        }
                                        <InputText placeholder={localization.labelUsername}
                                            autoFocus
                                            value={username.value}
                                            onChange={username.onChange}
                                            onKeyDown={(e) => {

                                                if (e.key === 'Enter') {

                                                    login();
                                                }
                                            }}
                                        />
                                    </div> */}

                                    {props.domainSelection ?
                                        <>
                                            <Dropdown
                                                value={selectedDomainName}
                                                onChange={(e) => setSelectedDomainName(e.value)}
                                                options={domainList}
                                                optionLabel="value"
                                                optionValue='value'
                                                showClear
                                                placeholder="Domain Seçimi"
                                                className="w-full mb-2" // Genişliği ayarlanabilir
                                                style={{ borderRadius: '6px', textAlign: 'justify' }}
                                            />

                                            <InputText
                                                placeholder={localization.labelUsername}
                                                autoFocus
                                                value={username.value}
                                                onChange={username.onChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        login();
                                                    }
                                                }}
                                                className="w-full mb-2"
                                            />

                                        </> :


                                        <div className="p-inputgroup bs-inputgroup mb-0">
                                            <span className="p-inputgroup-addon">
                                                <i className="pi pi-user"></i>
                                            </span>
                                            <InputText placeholder={localization.labelUsername}
                                                autoFocus
                                                value={username.value}
                                                onChange={username.onChange}
                                                onKeyDown={(e) => {

                                                    if (e.key === 'Enter') {
                                                        if (isOtp) {
                                                            otpLogin();
                                                        }
                                                        else {
                                                            login();
                                                        }
                                                    }
                                                }}
                                            />
                                        </div>

                                    }


                                    {(!isOtp) &&
                                        <div className="p-inputgroup bs-inputgroup">
                                            <span className="p-inputgroup-addon">
                                                <i className="pi pi-lock"></i>
                                            </span>
                                            <Password placeholder={localization.labelPassword}
                                                toggleMask
                                                feedback={false}
                                                value={password.value}
                                                onKeyDown={(e) => {

                                                    if (e.key === 'Enter') {

                                                        otpLogin();
                                                    }
                                                }}
                                                onChange={password.onChange}
                                            />

                                        </div>
                                    }
                                    {otpResponse != null &&
                                        <>
                                            <div className="p-inputgroup bs-inputgroup code-input">
                                                <span className="p-inputgroup-addon">
                                                    <i className="pi pi-mobile"></i>
                                                </span>
                                                <InputText placeholder={localization.labelMobileConfirmationCode}
                                                    autoFocus
                                                    value={mobileConfirmationCode.value}
                                                    onChange={mobileConfirmationCode.onChange}
                                                    onKeyDown={(e) => {

                                                        if (e.key === 'Enter') {                                                            
                                                            otpLogin();
                                                        }
                                                    }}
                                                />
                                                <br />
                                            </div>
                                        </>
                                    }


                                </div>
                                {
                                    props.captcha || wrongPassword ?
                                        <div className='bs-captcha'>
                                            <div className='bs-captcha-img'>
                                                <canvas id="bs-captcha-canvas"></canvas>
                                                <Button className='bs-captcha-btn'
                                                    onClick={() => {

                                                        reelCaptcha = otherTool.createCaptcha();
                                                        captcha.onReset()
                                                    }}
                                                    icon="pi pi-refresh" />
                                            </div>
                                            <div className='bs-input'>
                                                <InputText value={captcha.value}
                                                    onKeyDown={(e) => {

                                                        if (e.key === 'Enter') {

                                                            login();
                                                        }
                                                    }}
                                                    onChange={captcha.onChange} />
                                            </div>
                                        </div>
                                        : null
                                }
                                <br />
                                {
                                    props.rememberMe || props.forgotPassword ?
                                        <div className='bs-remember-me'>
                                            {props.rememberMe ?
                                                <div className="flex align-items-center bs-switch-and-label">
                                                    <InputSwitch onChange={e => setIsRememberMe(e.value)} checked={isRememberMe}></InputSwitch>
                                                    <label htmlFor="ingredient4" className="ml-2"> {localization.labelRememberMe}</label>
                                                </div>
                                                : null
                                            }
                                            {props.forgotPassword ?
                                                <a className='bs-forget-password'
                                                    onClick={() => changeForgetPassword(false)}>{localization.labelForgotPassword}
                                                </a>
                                                : null
                                            }
                                        </div>
                                        : null
                                }
                                {isOtp ? <Button onClick={otpLogin}
                                    loading={isLoading}
                                    className='bs-login-btn'
                                    icon="pi pi-check"
                                    label={otpResponse == null ? localization.labelLoginOtp : localization.labelLoginOtpValidate} /> :
                                    <Button onClick={login}
                                        loading={isLoading}
                                        className='bs-login-btn'
                                        icon="pi pi-check"
                                        label={localization.labelLogin} />
                                }
                                {
                                    props.edevlet ?

                                        <div className='other-login-options'>
                                            <h2><span>Veya</span></h2>
                                            <Button className='edevlet' label={localization.labelEdevlet} iconPos="left">
                                                <img alt="logo" src="https://play-lh.googleusercontent.com/6cfkfK3VEs461QmIMdZHHwOeacOdsCMo-ig4P7pQ8CV3tWsVTQLL8pU0kyfdgcfZS8ck" className="h-2rem"></img>
                                            </Button>
                                        </div>
                                        : null
                                }
                                {props.register ?
                                    <a className='bs-register' href=''>{localization.labelRegisterText} <b>{localization.labelRegister}</b></a>
                                    : null
                                }
                                <p>{props.version}</p>

                            </>
                            :
                            <div className='bs-forget-password-area'>
                                <i className="pi pi-lock"></i>
                                <h1>{localization.labelResetPassword}</h1>
                                <h4>{localization.labelResetPasswordText}</h4>
                                <div className="card flex flex-column">
                                    <div className="p-inputgroup bs-inputgroup">
                                        <span className="p-inputgroup-addon">
                                            <i className="pi pi-user"></i>
                                        </span>
                                        <InputText placeholder={localization.labelUsernameOrEmail}
                                            value={username.value}
                                            autoFocus
                                            onChange={username.onChange}
                                            onKeyDown={(e) => {

                                                if (e.key === 'Enter') {

                                                    sendResetPasswordLink();
                                                }
                                            }}
                                        />
                                    </div>
                                    <Button loading={isResetLoading}
                                        className='bs-btn'
                                        onClick={() => sendResetPasswordLink()}
                                        label={localization.labelSentMail}
                                        icon="pi pi-send" />
                                    <p onClick={() => changeForgetPassword(true)}>
                                        {localization.labelBackLoginScreen}
                                    </p>
                                </div>
                            </div>
                        }

                    </div>
                </div >
            </div >
        </>
    );
}

export default Login;
// export class OzLogin extends React.Component {

//     state = {
//         username: '',
//         password: '',
//         isLoading: false
//     };

//     constructor(props) {

//         super(props);

//         localStorage.clear("user_");

//         window.USER_API_URL = props.url;
//     }

//     render = () => {

//         let loginButton = {
//             Text: "giriş yap",
//             Icon: "check",
//             Disabled: false
//         };

//         if (this.state.isLoading) {

//             loginButton = {
//                 Text: "giriş yapılıyor...",
//                 Icon: "hourglass_empty",
//                 Disabled: true
//             };
//         }

//         return (
//             <>
//                 <ToastContainer />
//                 <div className="login">
//                     <div style={{ paddingLeft: 110, paddingTop: 10, float: "left" }}>
//                         <Map style={
//                             {
//                                 color: "#1976d2",
//                                 fontSize: 40,
//                             }} />
//                     </div>
//                     <div style={{ float: "left", paddingLeft: 13, paddingTop: 15 }}>
//                         <h2>login app</h2>
//                     </div>
//                     <div style={{ paddingLeft: 30, paddingRight: 30, paddingBottom: 10 }}>
//                         <Grid
//                             container
//                             spacing={2}
//                             alignItems="flex-end">
//                             <Grid item xs={1} style={{ marginBottom: 15 }}>
//                                 <AccountCircle />
//                             </Grid>
//                             <Grid item xs={11}>
//                                 <TextField
//                                     value={this.state.username}
//                                     onKeyPress={this.handlePress}
//                                     onChange={this.handleChange}
//                                     autoFocus
//                                     name='username'
//                                     margin="dense"
//                                     label="username or e-mail"
//                                     fullWidth
//                                 />
//                             </Grid>
//                         </Grid>
//                         <Grid
//                             container
//                             spacing={2}
//                             alignItems="flex-end">
//                             <Grid item xs={1} style={{ marginBottom: 15 }}>
//                                 <Lock />
//                             </Grid>
//                             <Grid item xs={11}>
//                                 <TextField
//                                     value={this.state.password}
//                                     onKeyPress={this.handlePress}
//                                     onChange={this.handleChange}
//                                     name='password'
//                                     margin="dense"
//                                     label="password"
//                                     type="password"
//                                     fullWidth
//                                 />
//                             </Grid>
//                         </Grid>
//                     </div>
//                     <div className="login-button">
//                         <Button
//                             disabled={loginButton.Disabled}
//                             type="submit"
//                             style={{ width: 200 }}
//                             startIcon={<Icon>{loginButton.Icon}</Icon>}
//                             variant="contained"
//                             onClick={this.login}
//                             color="primary">
//                             {loginButton.Text}
//                         </Button>
//                     </div>
//                 </div>
//             </>
//         );
//     }

//     handleChange = (e) => {

//         const { name, value } = e.target;

//         this.setState({ [name]: value });
//     }

//     handlePress = (e) => {

//         if (e.key === 'Enter') {

//             this.login();
//         }
//     }

//     login = () => {

//         const { username, password } = this.state;

//         if (!username || !password) {

//             toast.info("kullanıcı adı ve şifre giriniz.");

//             return;
//         }

//         this.setState({ isLoading: true })

//         authenticationService.login(username, password).
//             then(response => {

//                 if (!response.success) {

//                     toast.error(response.message);

//                     this.setState({ isLoading: false })

//                     return;
//                 }

//                 if (this.props.onSuccess) {

//                     this.props.onSuccess(response.data);
//                 }

//                 this.setState({ isLoading: false })
//             }).
//             catch(ex => {

//                 console.error(ex);

//                 toast.error("something went wrong");

//                 this.setState({ isLoading: false })
//             });
//     }
// }